export default "__VITE_ASSET__c1f1abf1__"